import { CardHead } from './CardHead';
import { PillTag } from './PillTag';
import './ListPageShell.css';

/**
 * Mockup parity wrapper for list pages (backoffice.html#view-customer-360):
 *   <article class="card">
 *     <div class="card-head"> title + sub + pill/actions </div>
 *     <div class="ag-wrap">   toolbar + grid + footer </div>
 *   </article>
 *
 * Props:
 *   title       — string
 *   subtitle    — string
 *   meta        — string | ReactNode → renders as right-side PillTag (mockup customer360Meta)
 *   actions     — ReactNode → extra header-right buttons (e.g. "+ Yeni Kayıt")
 *   toolbar     — ReactNode → filter input + sort + page-size row (above grid)
 *   footer      — ReactNode → e.g. pagination
 *   children    — the grid (MUI DataGrid / StandardDataGrid)
 */
export function ListPageShell({ title, subtitle, meta, actions, toolbar, footer, children, className }) {
  const right = (
    <>
      {actions}
      {meta != null && (typeof meta === 'string' ? <PillTag>{meta}</PillTag> : meta)}
    </>
  );
  const cls = ['ui-list-page', className].filter(Boolean).join(' ');
  return (
    <article className={cls}>
      <CardHead title={title} subtitle={subtitle} actions={right} />
      {toolbar && <div className="ui-list-page-toolbar">{toolbar}</div>}
      <div className="ui-list-page-body">{children}</div>
      {footer && <div className="ui-list-page-foot">{footer}</div>}
    </article>
  );
}
